import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyPointsByMonth, CompanyPointsHistory } from '../../model/company-wallet-points-transactions';
import { WalletPointsTransactionService } from '../../services/wallet-points-transaction.service';
import { MatDialog } from '@angular/material/dialog';
import { EmployeesListComponent } from '../../../../features/companies/components/rewarded-employees/employees-list/employees-list.component';

@Component({
  selector: 'app-company-wallet-transactions',
  templateUrl: './company-wallet-transactions.component.html',
  styles: ``
})
export class CompanyWalletTransactionsComponent {
  @Input() id!: string;
  @Input() currentPoints!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();

  selectedRequest!: any;

  companyPoints!: CompanyPointsHistory | null;
  companyPointsLoading = false;

  companyPointsByMonthLoading = false;

  today = new Date();

  constructor(private service: WalletPointsTransactionService,
    private dialog: MatDialog) {
  }


  ngOnInit(): void {
    this.CompanyPointsHistory();
  }

  CompanyPointsHistory() {
    this.companyPointsByMonthLoading = true;
    this.service.CompanyPointsHistory(this.id).subscribe((res: CompanyPointsHistory) => {
      this.companyPoints = res;
      this.companyPointsByMonthLoading = false;
    })
  }

  getCompanyHistoryByMonth(year_and_month: any, i: number) {
    this.companyPoints!.data[i].loading = true;
    this.service.GetCompanyPointsHistoryByMonth(this.id, year_and_month).subscribe((res: CompanyPointsByMonth) => {
      this.companyPoints!.data[i].history = res;
      this.companyPoints!.data[i].loading = false;

      this.companyPoints!.data[i].history.data.map((item) => {
        item.isShow = false;
      });
    })
  }

  ShowHideDetails(i: any,x: any, isShow: boolean) {
    let target = this.companyPoints!.data[i].history.data[x];
    target.isShow = isShow;
    this.updateExpireAter(target)
    window.setInterval(() => {
      this.updateExpireAter(target)
    }, 1000)
  }

  updateExpireAter(target: any) {
    if (target.message.expire_after > 0) {
      target.message.expire_after = target.message.expire_after - 1;
    }
  }

  onOpenEmployeesList(data: any) {
    const dialog = this.dialog.open(EmployeesListComponent, {
      width: "540px",
      data: data
    })
    dialog.afterClosed().subscribe((result) => {

    })
  }

}
